import { Box, Grid, Typography } from '@mui/material'

import { Address } from '@ecm/data/Address'
import { Area, getAreasWithAddresses } from '@ecm/data/Area'
import AddressCard from '@ecm/ui/component/addresses/AddressCard'
import Anchor from '@ecm/ui/element/Anchor'
import { useVisibleAddressesContext } from '@ecm/ui/provider/VisibleAddressesProvider'

type StateAddressListProps = {
  allAddresses?: Address[]
  showHeader?: boolean
}

const StateAddressList = ({ allAddresses, showHeader }: StateAddressListProps) => {
  const { visibleAddresses: contextVisibleAddresses } = useVisibleAddressesContext()
  const visibleAddresses = allAddresses ?? contextVisibleAddresses

  return (
    <Box overflow="auto" maxHeight="inherit" padding={{ md: '1.5em' }} boxSizing="border-box">
      {getAreasWithAddresses(visibleAddresses).map((area: Area) => (
        <Box key={area.slug}>
          {showHeader && (
            <Grid container alignItems="baseline" justifyContent="space-between">
              <Typography variant="h4" component="h2" margin="0 0.5em 0 0">
                {area.name}
              </Typography>
              <Anchor
                href={`/addresses/${area.stateAbbreviation}/${area.city}`}
                prefetch={false}
                caret
              >
                {`See all ${area.name} addresses`}
              </Anchor>
            </Grid>
          )}

          {area.addresses.map(address => (
            <AddressCard key={address.slug} address={address} />
          ))}
        </Box>
      ))}
    </Box>
  )
}

export default StateAddressList
